// Component: SurveyErrorModal
// Purpose: Modal displayed when video file is too large for upload

import React from 'react';
import { X, AlertCircle } from 'lucide-react';

export const SurveyErrorModal = ({ showErrorModal, closeErrorModal }) => {
  if (!showErrorModal) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full mx-4 relative">
        {/* Close button */}
        <button 
          onClick={closeErrorModal}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <X className="h-5 w-5" />
        </button>
        
        <div className="flex flex-col">
          {/* Error Icon */}
          <div className="flex justify-center mb-4">
            <div className="rounded-full bg-red-100 p-3">
              <AlertCircle className="h-8 w-8 text-red-600" />
            </div>
          </div>
          
          {/* Title */}
          <h3 className="text-xl font-semibold text-gray-900 mb-3 text-center">
            File Size Too Large
          </h3>
          
          {/* Description */}
          <p className="text-gray-600 mb-4 text-center">
            Your video file is too large for our server to process.
            Please compress your video before uploading.
          </p>
          
          {/* Compression Instructions */}
          <div className="bg-gray-50 p-4 rounded-lg mb-5">
            <h4 className="font-medium text-gray-900 mb-2">How to compress your video:</h4>
            <ul className="space-y-2 text-sm text-gray-700 list-disc pl-5">
              <li>Record a shorter video (under 1 minute if possible)</li>
              <li>Use a lower resolution (720p instead of 1080p or 4K)</li>
              <li>Use a video compression app on your device:
                <ul className="mt-1 ml-4 text-xs text-gray-600 list-disc">
                  <li>iOS: Use the built-in trim and quality options in Photos</li>
                  <li>Android: Try "Video Compressor" from your app store</li>
                  <li>Web: Try services like Clideo or CloudConvert</li>
                </ul>
              </li>
            </ul>
          </div>
          
          {/* Action Button */}
          <button
            type="button"
            onClick={closeErrorModal}
            className="w-full bg-primary-600 text-white py-2.5 rounded-lg hover:bg-primary-700 font-medium"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
};


